<template>
    <Sidebar :is_empty="true" />
    <div class="content new-password-content" :class="{'is-loading': is_check_code}">
        <div class="inner">
            <Header :title="title" :top_text="top_text" :text="text" />

            <Form :schema="schema" @submit="submit" :values="values" v-slot="{ errors, success }" class="form-wrap" v-if="step === 1">
                <Field type="password" k="password" placeholder="Password" :error_msg="errors.password" :is_success="success.password" @update="update"/>
                <Field type="password" k="repeat_password" placeholder="Repeat password" :error_msg="errors.repeat_password" :is_success="success.repeat_password" @update="update"/>
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit">Continue</Button>
                </div>
            </Form>

            <div class="code-box" v-else-if="step === 2">
                <VerificationCode 
                ref="code" 
                    @resend="sendEmail" 
                    :countdown="countdown" 
                    :error_msg="code_error_msg" 
                    @update="update" 
                    :class="[{'success': code.length === 6 && !code_error}, {'error': code_error}]"
                />
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" @click="checkCode">Continue</Button>
                </div>
            </div>

            <Form :schema="schema2" @submit="submit" :values="values2" v-slot="{ errors, success }" class="form-wrap full-width" v-else-if="step === 3">
                <Transition name="fade" v-show="is_show_cropper">
                    <div class="cropper-wrap">
                        <i @click="is_show_cropper = false"><svg-icon name="close" /></i>
                        <div class="box">
                            <cropper
                                ref="cropper"
                                :src="image.src"
                                :debounce="false"
                                :stencil-props="{
                                    aspectRatio: 1
                                }"
                            /> 
                            <Button size="40" color="dark-blue" @click.native="crop">Ok</Button>

                        </div>

                    </div>
                </Transition>

                <div class="avatar">
                    <!-- @click="$refs.file.click()" -->
                    <img :src="img" />
                    <i><svg-icon name="image" /></i>
                    <input type="file" ref="file" @change="loadImage($event)" accept="image/*">
                </div>
                
                <div class="two-cloumn">
                    <Field type="text" k="first_name" placeholder="First name" label="First name" :error_msg="errors.first_name" :is_success="success.first_name" @update="update"/>
                    <Field type="text" k="last_name" placeholder="Last name" label="Last name" :error_msg="errors.last_name" :is_success="success.last_name" @update="update"/>
                </div>
                <!-- <div class="two-cloumn">
                    <Field type="select" :select_data="select_company" k="company" label="Company" placeholder="---Select---" :error_msg="errors.company" :is_success="success.company" @update="update" class="not-required"/>
                    <Field type="select" :select_data="select_department" k="department" label="Department" placeholder="---Select---" :error_msg="errors.department" :is_success="success.department" @update="update" class="not-required"/>
                </div> -->
                
                <div class="submit-wrap">
                    <Button size="40" color="dark-blue" type="submit">Done</Button>
                </div>
            </Form>

            <!-- <Footer /> -->
        </div>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Field from '@/components/ui/Field.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Button from '@/components/ui/Button.vue';
import Form from '@/components/ui/Form.vue';
import VerificationCode from '@/components/ui/VerificationCode.vue';
import { Cropper } from 'vue-advanced-cropper';


import Header from '@/components/login/Header.vue';
// import Footer from '@/components/login/Footer.vue';
import * as yup from 'yup';
import YupPassword from 'yup-password';
YupPassword(yup);
import 'vue-advanced-cropper/dist/style.css';


export default {
    name: 'onboard',

    data() {
        return {
            step: 1,
            top_text: 'Welcome!',
            title: 'Create new password',
            text: '',
            is_show_cropper: false,
            is_check_code: false,

            code: '',
            code_error: false,
            code_error_msg: '',
            is_countdown: false,
            countdown_timer: null,
            countdown_second: 300,
            countdown: 0,
            schema: yup.object().shape({
                password: yup.string()
                    .password()
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .min(14, 'Must be at least 14 characters')
                    .required('The password can’t leave as blank'),

                repeat_password: yup.string()
                    .oneOf(
                        [yup.ref('password'), null], 
                        'Passwords must match'
                    )
                    .password()
                    .minNumbers(1, 'Must have a number and special character')
                    .minSymbols(1, 'Must have a number and special character')
                    .minUppercase(1, 'Must contain at least 1 uppercase letter')
                    .min(14, 'Must be at least 14 characters')
                    .required('The repeat password can’t leave as blank'),
            }),

            schema2: yup.object().shape({
                first_name: yup.string().required('Your first name can’t leave as blank'),
                last_name: yup.string().required('Your last name can’t leave as blank'),
                company: yup.string(),
                // .required('Your company can’t leave as blank'),
                department: yup.string(),

            }),

            values: {
                password: '',
                repeat_password: '',
            },

            values2: {
                first_name: '',
                last_name: '',
                company: '',
                department: '',
            },

            select_company: [
            ],

            select_department: [
            ],

            img: require('@/assets/images/user.png'),
            img_blob: null,
			image: {
				src: null,
				type: null
			}
        }
    },

    components: {
        Header,
		Cropper,
        Sidebar,
        Form,
        Field,
        Checkbox,
        Button,
        VerificationCode,
    },

    methods: {
        update(obj) {
            switch (this.step) {
                case 1:
                    Object.keys(this.values).forEach(key => {
                        if (key === obj.key) this.values[key] = obj.val;
                    });
                    break;

                case 2:
                    this.code = '';
                    for (let index = 0; index < obj.length; index ++) {
                        // console.log(typeof obj[index], obj[index])
                        if (obj[index]) this.code = this.code + obj[index];
                    }

                    // console.log(this.code)

                    if (this.code.length === 6) {
                        this.code_error = false;
                        this.code_error_msg = '';
                        
                        this.checkCode();
                    }

                    break;

                case 3:
                    Object.keys(this.values2).forEach(key => {
                        if (key === obj.key) this.values2[key] = obj.val;
                    });
                    break;
            }

        },
        checkCode() {
            this.is_check_code = true;

            this.$ajax('/settings/check-email-verify-code', {
                method: 'post',
                data: {
                    email: this.$store.state.user_data.email,
                    code: this.code,
                },
            }).then(res => {
                this.is_check_code = false;
                // this.done();
                this.step = 3;
                
            }).catch(err => {
                this.is_check_code = false;
                // this.done();

                if (err && err.response && err.response.data.data) {
                    this.code_error = true;
                    this.code_error_msg = err.response.data.data.message;
                }
            });

        },
        sendEmail() {
            this.countdown = this.countdown_second;
            this.countdown_timer = window.setInterval(() => {
                this.countdown --;
                
                if (this.countdown === 0) {
                    window.clearInterval(this.countdown_timer);
                }
            }, 1000);
            this.$ajax('/settings/send-email-verify-code', {
                method: 'post',
                data: {
                    email: this.$store.state.user_data.email,
                },
            });
        },

        submit() {
            if (this.step !== 3) {
            //     this.$router.push('/?welcome');
            // } else {
                this.step ++;
            }

            switch (this.step) {
                case 1:
                    this.top_text = 'Welcome!';
                    this.text = '';
                    this.title = 'Create new password';
                    break;
                    
                case 2:
                    this.top_text = '';
                    this.text = `We have sent a 6 digit verification code to <span class="link">${this.$store.state.user_data.email}</span>, please enter the code below.  The code will expire after 5 minutes.`;
                    this.title = 'Help keep your account secure';
                    this.sendEmail();
                    break;

                case 3:
                    this.text = '';
                    this.title = 'Account setup';
                    this.top_text = '';
                    let form_data = new FormData();

    
                    let company_id = 0;
                    let department_id = 0;
                    this.select_company.forEach(item => {
                        if (item.name === this.values2.company) {
                            company_id = item.id;
                        }
                    });
                    this.select_department.forEach(item => {
                        if (item.name === this.values2.department) {
                            department_id = item.id;
                        }
                    });

                    form_data.append('email', this.$store.state.user_data.email);
                    // if (department_id) form_data.append('department_id', department_id);
                    // if (this.values2.company) form_data.append('company_id', company_id);
                    form_data.append('first_name', this.values2.first_name);
                    form_data.append('last_name', this.values2.last_name);
                    form_data.append('password', this.values.password);
                    form_data.append('confirm_password', this.values.repeat_password);
                    if (this.img_blob) form_data.append('avatar', this.img_blob);
                    this.is_check_code = true;
                    this.$ajax(`/settings/enable-portal-user`, {
                        method: 'post',
                        data: form_data,
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then(res => {
                        this.is_check_code = false;
                        this.$store.state.user_data = res.data.data;
                        if (this.$store.state.user_data.is_first_login === 0) {
                            window.location.replace('/landing?is_onboard=1');
                        }
                    }).catch(err => {
                        this.is_check_code = false;
                        // console.log(err.response);
                        this.is_file_error = true;
                        this.file_error_msg = err.response.data.data.message;

                    });
                    break;
            }
        },

        // done() {
        //     if (this.code.length !== 6) {
        //         this.code_error = true;
        //         this.code_error_msg = '* Can’t be be blank';
        //     } else {
        //         this.step = 3;
        //     }
        // },

		crop() {
			const { canvas } = this.$refs.cropper.getResult();
			canvas.toBlob((blob) => {
                this.img_blob = blob;
                this.img = URL.createObjectURL(blob)
                this.is_show_cropper = false;

            }, this.image.type);
		},

		reset() {
			this.image = {
				src: null,
				type: null
			}
		},

        getMimeType(file, fallback = null) {
            const byteArray = (new Uint8Array(file)).subarray(0, 4);
            let header = '';

            for (let i = 0; i < byteArray.length; i++) {
                header += byteArray[i].toString(16);
            }
            switch (header) {
                case "89504e47":
                    return "image/png";
                case "47494638":
                    return "image/gif";
                case "ffd8ffe0":
                case "ffd8ffe1":
                case "ffd8ffe2":
                case "ffd8ffe3":
                case "ffd8ffe8":
                    return "image/jpeg";
                default:
                    return fallback;
            }
        },

		loadImage(event) {
			// Reference to the DOM input element
			const { files } = event.target;
            const self = this;
			// Ensure that you have a file before attempting to read it
			if (files && files[0]) {
				// 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
				if (this.image.src) {
					URL.revokeObjectURL(this.image.src)
				}
				// 2. Create the blob link to the file to optimize performance:
				const blob = URL.createObjectURL(files[0]);
				
				// Create a new FileReader to read this image binary data
				const reader = new FileReader();
				reader.onload = (e) => {
					this.image = {
						src: blob,
						type: self.getMimeType(e.target.result, files[0].type),
					};
				};
				reader.readAsArrayBuffer(files[0]);

                this.is_show_cropper = true;
			}
		},
	},

	destroyed() {
		if (this.image.src) {
			URL.revokeObjectURL(this.image.src)
		}
	},

    mounted() { 
        // this.$ajax.get(`/settings/company-list`).then(res => {
        //     this.select_company = res.data.data;
        // });
        let merchant_account_id = window.localStorage.getItem('merchant_account_id');
        if (merchant_account_id) {
            this.$ajax(`/select-current-merchant-account`, {
                method: 'post',
                data: {
                    merchant_account_id: merchant_account_id
                },
            });

            // this.merchant_account_id = Number(merchant_account_id);
            window.localStorage.removeItem('merchant_account_id');
        }

        this.$ajax.get(`/settings/company-list`).then(res => {
            this.select_company = res.data.data;
        });

        this.$ajax.get(`/settings/department-list`).then(res => {
            this.select_department = res.data.data;
            this.select_department.forEach(item => {
                item.name = item.name.charAt(0).toUpperCase() + item.name.slice(1);
            });
        });
    },

}
</script>

<style lang="scss">
    .new-password-content {
        display: flex;
        align-items: center;
        justify-content: center;

        &.is-loading {
            .form-wrap,
            .code-box {
                opacity: .5;
                pointer-events: none;
            }
        }

        .form-wrap {
            &.full-width {
                width: 480px;

            }
            
            .ui-input > label {
                &::after {
                    content: ' *';
                    color: var(--alert);
                }
            }
            
            .ui-input.not-required > label {
                &::after {
                    display: none;
                }
            }

            .two-cloumn {
                display: flex;
                align-items: center;
                gap:8px;

                .ui-input {
                    width: calc(50% - 8px);
                    margin:0;
                    // &:nth-child(1) {
                    //     margin-right: 8px;
                    //     margin-bottom: 0;
                    // }

                    // &:nth-child(2) {
                    //     margin-left: 8px;
                    //     margin-bottom: 0;
                    // }
                }
            }
        }

        .submit-wrap {
            margin: 44px 16px ;
            text-align: center;

            .ui-button {
                display: block;
                width: 180px;
                text-align: center;
                margin: 0 auto 16px;
            }

            a {
                font: var(--font-fg-12);
                color: var(--dark-blue);
            }
        }

        .login-header {
            max-width: 360px;
            margin-bottom: 46px;

            p {
                margin-top: 5px;
                font-size: 14px;
            }
        }

        .avatar {
            height: 128px;
            width: 128px;
            position: relative;
            margin: 0 auto 16px;

            img {
                height: 100%;
                width: 100%;
                display: block;
                border-radius: 50%;
            }

            i {
                height: 32px;
                width: 32px;
                border-radius: 50%;
                background-color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                z-index: 1;
                right: 0;
                bottom: 0;

                svg {
                    height: 12px;
                    width: 12px;
                    display: block;
                    fill: var(--black-90);
                }
            }

            input {
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                opacity: 0;
                top: 0;
                z-index: 3;
                cursor: pointer;
            }
        }

        .cropper-wrap {
            position: fixed;
            z-index: 999;
            height: 100%;
            left: 0;
            top: 0;
            width: 100%;
            background-color: rgba(#fff, .5);
            backdrop-filter: blur(5px);

            i {
                cursor: pointer;
                height: 42px;
                width: 42px;
                position: absolute;
                z-index: 3;
                right: 24px;
                top: 24px;

                svg {
                    display: block;
                    height: 100%;
                    width: 100%;
                    fill: var(--dark-blue);
                }
            }

            .box {
                width: 580px;
                height: 580px;
                position: absolute;
                left: 50%;
                top: 50%;
                margin: -290px 0 0 -290px;

                .ui-button {
                    width: 80px;
                    display: block;
                    text-align: center;
                    margin: 12px auto 0;
                }
            }
        }
    }

</style>